﻿import { upOrDownOnScrollWheel } from "./HelperFunctions";

export const navigationFunctions = () => {
    const windowWidth = window.innerWidth;
    const mainNavContainer = document.querySelector<HTMLElement>(".main-site-header");

    if (!mainNavContainer) return;
        
    if (windowWidth >= 991) {
        closeNavOnBodyClick();
    }
        
    burgerMenuClickHandler(mainNavContainer);
    makeNavSticky(mainNavContainer);
    adjustNavWidth();
    addBackBtn();
    openNavLevelsClickHandler();
    applyBackBtnClickHandler();
};

//Click Handlers
const burgerMenuClickHandler = (mainHeader: HTMLElement) => {
    const burgerMenu = document.querySelector(".main-site-header__burger-menu");
    const childNavs = document.querySelectorAll(".navList");

    if (!burgerMenu) return;

    burgerMenu.addEventListener("click", () => {
        mainHeader.classList.toggle("nav-open");
        document.body.classList.toggle("nav-open");

        childNavs.forEach((el) => {
            el.querySelectorAll('li.hasChildren')?.forEach((child) => {
                child.classList.remove("open");
            });
            el.classList.remove("open");
        });
    });
};

const openNavLevelsClickHandler = () => {
    const hasChildren = document?.querySelectorAll(
        ".main-site-header .hasChildren"
    );

    if (!hasChildren) return;

    hasChildren.forEach((el) => {
        const icons = el.querySelectorAll(".icon");

        icons.forEach((icon) => {
            icon.addEventListener("click", (event) => {
                event.stopImmediatePropagation();
                const target = event.target as HTMLElement;
                const parent = target.parentElement;
                if (!parent) return;

                const siblings = parent
                    ?.closest(".navList")
                    ?.querySelectorAll(".hasChildren");

                parent.classList.toggle("open");

                siblings?.forEach((sib) => {
                    if (sib !== parent) {
                        sib.classList.remove("open");
                    }
                });
            });
        });
    });
};

const applyBackBtnClickHandler = () => {
    const backBtns = document.querySelectorAll(".nav-back-btn");

    backBtns.forEach((el) => {
        el.addEventListener("click", () => {
            el.closest(".hasChildren")?.classList.remove("open");
        });
    });
};

const closeNavOnBodyClick = () => {
    window.addEventListener("click", (event) => {
        const target = event.target as HTMLElement;
        const nav = document.querySelector(".navList");
        const openNavs = document.querySelectorAll(".hasChildren");

        if (target !== nav && !nav?.contains(target)) {
            openNavs.forEach((el) => {
                el.classList.remove("open");
            });
        }
    });
};

//Changes to the DOM
const addBackBtn = () => {
    const hasChildren = document?.querySelectorAll("li.hasChildren");

    if (!hasChildren) return;

    hasChildren.forEach((el) => {
        const backBtn = document.createElement("div");
        backBtn.classList.add("nav-back-btn");
        backBtn.innerHTML = "Back";
        el.querySelector(".navList")?.prepend(backBtn);
    });
};

const makeNavSticky = (elm: HTMLElement) => {
    upOrDownOnScrollWheel(elm);
};

const adjustNavWidth = () => {
    const links = document.querySelectorAll(
        ".main-site-header .navList > .last > ul > li"
    );

    links.forEach((link) => {
        if (link.classList.contains("hasChildren")) {
            const icon = link.querySelector<HTMLSpanElement>(".icon");
            icon?.addEventListener("click", () => {
                const tile = link.querySelector("ul");
                const tileSize = tile?.getBoundingClientRect();
                const parentNav = link?.parentElement?.closest("ul");
                if ( !tile || !tileSize || !parentNav) return;

                const totalTileSize: number = tileSize.right + tileSize.width;
                const windowMaxWidth: number = Math.max(
                    window.innerWidth || document.documentElement.clientWidth
                );

                if (totalTileSize > windowMaxWidth) {
                    tile.style.width = "fit-content";
                    parentNav.style.left = "auto";
                    parentNav.style.right = "100%";
                }
            });
        }
    });
};
